<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Contraseña CIEC con INE</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'SAT' }, { label: 'Contraseña CIEC con INE' }]" />
    </div>
  </section>

  <section wrapper>
    <p-tabView [activeIndex]="1">
      <p-tabPanel tabindex="1" header="Ingresar externo">
        <div [formGroup]="formUpload" class="page-section card">
          <div class="card-body d-flex flex-column gap-3">
            <div class="row">
              <div class="col-12 col-sm-4">
                <div class="mb-3 mb-sm-0 flex flex-column gap-2">
                  <p-select
                    formControlName="provider"
                    [options]="providers"
                    optionLabel="provider"
                    optionValue="id"
                    [checkmark]="true"
                    [filter]="true"
                    filterBy="provider"
                    [showClear]="true"
                    placeholder="Proveedor"
                    class="w-100 h-50px"
                  >
                  </p-select>
                  <small class="ps-2">Proveedor <span class="text-danger">Requerido *</span></small>
                </div>
              </div>
              <div class="col-12 col-sm-4">
                <div class="flex flex-column gap-2">
                  <p-inputMask formControlName="curp" mask="******************" placeholder="CURP" styleClass="w-100 h-50px"></p-inputMask>

                  <small class="ps-2"><span class="text-danger">Requerido *</span></small>
                </div>
              </div>
              <div class="col-12 col-sm-4">
                <p-button label="Guardar" class="d-block h-50px" styleClass="h-100" [loading]="isSaving" (onClick)="save()" [disabled]="this.formUpload.invalid" />
              </div>
            </div>
          </div>
        </div>

        <div class="page-section card">
          <div class="card-body p-0">
            <p-table #dt1 [value]="this.list" [rows]="25" [showCurrentPageReport]="true" [rowsPerPageOptions]="[25, 50, 100]" [paginator]="true" [globalFilterFields]="['curp']">
              <ng-template pTemplate="caption">
                <div class="d-flex align-items-stretch justify-content-between gap-2">
                  <p-inputgroup>
                    <p-iconfield class="w-100">
                      <p-inputicon styleClass="pi pi-search" />
                      <input type="text" pInputText [(ngModel)]="searchValue" (input)="dt1.filterGlobal(searchValue, 'contains')" placeholder="Buscar por CURP." class="w-100 h-50px rounded-end-0" />
                    </p-iconfield>
                    <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
                      <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
                    </p-inputgroup-addon>
                  </p-inputgroup>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th>CURP</th>
                  <th>FECHA</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-item>
                <tr>
                  <td class="text-nowrap">{{ item.curp }}</td>
                  <td class="text-nowrap">{{ item.dateCreated | date : "longDate" }}</td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="6">No se encontraron registros.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </section>
</backbone>
